export default __webpack_public_path__ + "static/19-8f7264608a8a6ff156772f402fc612be.webp";